import React, { memo } from 'react';
import { useTranslation } from 'i18n';
import { nameValueParser, nameValueTransformer, stringValueFormatter } from './utils';
import FilterSelectHandler from './FilterSelectHandler';

export interface IPriceFilterProps {
  disabled?: boolean;
}

const items = ['free', 'paid'];

const PriceFilter: React.FC<React.PropsWithChildren<IPriceFilterProps>> = (props) => {
  const { disabled } = props;
  const [t] = useTranslation();

  return (
    <FilterSelectHandler
      name="price"
      placeholder={t<string>('common:filter.price')}
      disabled={disabled}
      items={items}
      labelFormatter={(item) => t(`common:general.${item}`)}
      valueFormatter={stringValueFormatter}
      valueTransformer={nameValueTransformer}
      valueParser={nameValueParser}
      clearValueParser={(queryParams) => {
        let query: {
          tickets_sale_status?: undefined;
          price: undefined;
        } = {
          price: undefined,
        };
        if (queryParams.tickets_sale_status) {
          query = {
            ...query,
            tickets_sale_status: undefined,
          };
        }
        return query;
      }}
    />
  );
};

export default memo(PriceFilter);
